export const FETCH_REQUESTS = 'ADMIN_HELP_DESK/FETCH_REQUESTS';
export const FETCH_REQUESTS_SUCCESS = 'ADMIN_HELP_DESK/FETCH_REQUESTS_SUCCESS';
export const FETCH_REQUESTS_ERROR = 'ADMIN_HELP_DESK/FETCH_REQUESTS_ERROR';
export const SEND_RESPONSE = 'ADMIN_HELP_DESK/SEND_RESPONSE';
export const SEND_RESPONSE_SUCCESS = 'ADMIN_HELP_DESK/SEND_RESPONSE_SUCCESS';
export const SEND_RESPONSE_ERROR = 'ADMIN_HELP_DESK/SEND_RESPONSE_ERROR';
export const CLOSE_TICKET = 'ADMIN_HELP_DESK/CLOSE_TICKET';
export const CLOSE_TICKET_SUCCESS = 'ADMIN_HELP_DESK/CLOSE_TICKET_SUCCESS';
export const CLOSE_TICKET_ERROR = 'ADMIN_HELP_DESK/CLOSE_TICKET_ERROR';
export const SET_ID_MODAL = 'ADMIN_HELP_DESK/SET_ID_MODAL';
export const SET_ACTIVE_PAGE = 'ADMIN_HELP_DESK/SET_ACTIVE_PAGE';
export const RESET_STATE = 'ADMIN_HELP_DESK/RESET_STATE';
export const SET_REQUEST = 'ADMIN_HELP_DESK/SET_REQUEST';
export const SET_REQUEST_FIELD = 'ADMIN_HELP_DESK/SET_REQUEST_FIELD';
export const RESET_REQUEST = 'ADMIN_HELP_DESK/RESET_REQUEST';
export const SET_SORT = 'ADMIN_HELP_DESK/SET_SORT';
export const SET_SEARCH = 'ADMIN_HELP_DESK/SET_SEARCH';
export const SET_SEARCH_TYPE = 'ADMIN_HELP_DESK/SET_SEARCH_TYPE';
export const SET_RESPONSE_MESSAGE = 'ADMIN_HELP_DESK/SET_RESPONSE_MESSAGE';